angular.module('vastdesk').
  component('thirdPartyFees',  {
    bindings: {
      formName: '@',
      formId: '@',
      nested: '<',
      thirdPartyFeeMetric: '@',
      thirdPartyFee: '<',
      thirdPartyFeeCurrency: '@',
      thirdPartyMetricMappings: '<',
      removeFeeFromRevenue: '<',
      removeFeeFromBid: '<',
      removeFeeFromBidEnabled: '<',
      currencyOptions: '<',
      currencyEditable: '<'
    },
    template: require("../templates/thirdPartyFees.html"),
    controllerAs: '$thirdPartyFeesCtrl',
    controller: function() {
      var self = this;

      this.METRIC_REQUESTS = '0';
      this.METRIC_IMPRESSIONS = '1';
      this.METRIC_DIFF = '2';
      this.METRIC_REVSHARE = '3';

      this.clearRemoveFeeFromRevenue = function(removeFeeFromBid) {
        if (!removeFeeFromBid) {
          self.removeFeeFromRevenue = false;
        }
      };
    }
});
